import { withRouter } from 'react-router-dom';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { connect } from 'react-redux';
import { setSnackbar } from '../../../redux/actions';

import BaseOverview from './base-overview';

class MerchantOverview extends BaseOverview {
  constructor(props) {
    const statType = 'merchant-overview';
    const tableName = 'merchant-overview';

    super(props, statType, tableName);
  }
}

class MerchantEdOverview extends BaseOverview {
  constructor(props) {
    const statType = 'merch-ed-overview';
    const tableName = 'merch-ed-overview';

    super(props, statType, tableName);
  }
}

class PublisherOverview extends BaseOverview {
  constructor(props) {
    const statType = 'publisher-overview';
    const tableName = 'publisher-overview';

    super(props, statType, tableName);
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setSnackbar: msg => dispatch(setSnackbar(msg)),
  };
};

const MerchOverview = withRouter(connect(null, mapDispatchToProps)(MerchantOverview));
const MerchEdOverview = withRouter(
  connect(null, mapDispatchToProps)(withLDConsumer()(MerchantEdOverview)),
);
const PubOverview = withRouter(connect(null, mapDispatchToProps)(PublisherOverview));

export { MerchOverview, MerchEdOverview, PubOverview };
